

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "./storage";
import Footer from "./Footer";

const MissingCashback = () => {
  const navigate = useNavigate();
  let token = secureLocalStorage.getItem("n_token");

  const [step, setStep] = useState(1); // 1: store list, 2: dates, 3: order id, 4: amount+desc
  const [loading, setLoading] = useState(true);

  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);

  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  const [orderId, setOrderId] = useState("");
  const [orderAmount, setOrderAmount] = useState("");
  const [description, setDescription] = useState("");

  const [myClaims, setMyClaims] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // Step 1: Visited stores load karo
  const fetchVisitedStores = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/my_visited_stores`,
        { headers: { token } }
      );
      if (res.data?.success) {
        setStores(res.data.data);
      }
    } catch (error) {
      console.log("Error fetching visited stores", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchMyClaims = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/my_missing_cashback_list`,
        { headers: { token } }
      );
      if (res.data?.success) {
        setMyClaims(res.data.data);
      }
    } catch (error) {
      console.log("Error fetching claims", error);
    }
  };

  useEffect(() => {
    fetchVisitedStores();
    fetchMyClaims();
  }, []);

  // Step 1 se Step 2 — store select karne pe uski dates fetch karo
  const handleStoreSelect = async (store) => {
    setSelectedStore(store);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/my_click_dates?store_id=${store.store_id}`,
        { headers: { token } }
      );
      if (res.data?.success) {
        setDates(res.data.data);
      }
    } catch (error) {
      console.log("Error fetching dates", error);
    }
    setStep(2);
  };

  const handleDateSelect = (dateObj) => {
    setSelectedDate(dateObj);
    setStep(3);
  };

  const handleOrderIdContinue = () => {
    if (!orderId.trim()) {
      alert("Please enter your Order ID");
      return;
    }
    setStep(4);
  };

  const handleSubmit = async () => {
    if (!orderAmount || orderAmount <= 0) {
      alert("Please enter a valid order amount");
      return;
    }

    setSubmitting(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/raise_missing_cashback`,
        {
          store_id: selectedStore.store_id,
          click_id: selectedDate?.click_id || null,
          order_id: orderId,
          order_date: selectedDate?.date,
          order_amount: orderAmount,
          description,
        },
        { headers: { token } }
      );

      if (res.data?.success) {
        alert("Your claim has been submitted successfully!");
        // Reset everything
        setStep(1);
        setSelectedStore(null);
        setSelectedDate(null);
        setOrderId("");
        setOrderAmount("");
        setDescription("");
        setShowForm(false);
        fetchMyClaims();
      } else {
        alert(res.data?.message || "Something went wrong");
      }
    } catch (error) {
      const errMsg = error.response?.data?.message || "Something went wrong. Please try again.";
      alert(errMsg);   // "You have already submitted a claim for this Order ID."
    } finally {
      setSubmitting(false);
    }
  };

  const goBack = () => {
    if (step === 4) setStep(3);
    else if (step === 3) setStep(2);
    else if (step === 2) setStep(1);
  };

  const statusColors = {
    pending: { bg: "#fff8e1", color: "#f59e0b", label: "Pending" },
    need_details: { bg: "#fde8e8", color: "#c01e12", label: "Need Details" },
    resolved: { bg: "#e8f8ef", color: "#22c55e", label: "Resolved" },
    rejected: { bg: "#f0f0f0", color: "#666", label: "Rejected" },
  };

  return (
    <>
  

      <nav className="mc-breadcrumb">
        <div className="container">
          <span onClick={() => navigate("/")}>Home</span> / <b>Missing Cashback</b>
        </div>
      </nav>

      <section className="mc-section">
        <div className="container">

          {!showForm ? (
            <>
              {/* My Claims List */}
              <div className="mc-header-row">
                <h2>Missing Cashback</h2>
                <button className="mc-btn-primary" onClick={() => setShowForm(true)}>
                  + Raise New Claim
                </button>
              </div>

              {myClaims.length === 0 ? (
                <div className="mc-box">
                  <p>You have no missing cashback claims yet.</p>
                </div>
              ) : (
                <div className="mc-claims-list">
                  {myClaims.map((claim) => {
                    const info = statusColors[claim.status] || statusColors.pending;
                    return (
                      <div key={claim._id} className="mc-claim-card">
                        <div>
                          <p className="mc-claim-store">{claim.store_id?.name || "Store"}</p>
                          <p className="mc-claim-detail">Order ID: {claim.order_id}</p>
                          <p className="mc-claim-detail">Order Amount: ₹{claim.order_amount}</p>
                          {claim.status === "resolved" && (
                            <p className="mc-claim-resolved">Cashback Credited: ₹{claim.resolved_amount}</p>
                          )}
                          {claim.admin_response && (
                            <div className="mc-admin-message">
                              <strong>Message from CashKaroNa Team:</strong>
                              <p>{claim.admin_response}</p>
                            </div>
                          )}
                        </div>
                        <span className="mc-status-badge" style={{ background: info.bg, color: info.color }}>
                          {info.label}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          ) : (
            <div className="mc-box">
              {step > 1 && (
                <span className="mc-back-arrow" onClick={goBack}>←</span>
              )}
              {step === 1 && (
                <span className="mc-back-arrow" onClick={() => setShowForm(false)}>←</span>
              )}

              {/* STEP 1: Store Selection */}
              {step === 1 && (
                <>
                  <h2>Where did you shop?</h2>
                  <p className="tophe">These are the retailers you have visited via CashKaroNa in last 30 days</p>

                  {loading && <p className="mc-loading">Loading...</p>}

                  {!loading && stores.length === 0 && (
                    <p className="mc-loading">
                      Pichle 30 din me koi retailer visit nahi kiya gaya. Pehle kisi store pe click karke shopping karo.
                    </p>
                  )}

                  {!loading && stores.length > 0 && (
                    <div className="mc-grid">
                      {stores.map((s) => (
                        <div key={s.store_id} className="mc-card" onClick={() => handleStoreSelect(s)}>
                          <img
                            src={`${process.env.REACT_APP_API}uploads/${s.logo}`}
                            alt={s.name}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/assets/images/placeholder.jpg";
                            }}
                          />
                          <p className="mc-track-time">
                            Autotracks within {s.tracking_time} {s.tracking_unit}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}

              {/* STEP 2: Date Selection */}
              {step === 2 && selectedStore && (
                <>
                  <div className="mc-store-header">
                    <img
                      src={`${process.env.REACT_APP_API}uploads/${selectedStore.logo}`}
                      alt={selectedStore.name}
                    />
                  </div>
                  <h2>Select your shopping date</h2>

                  {dates.length === 0 ? (
                    <p className="mc-loading">No click history found for this store.</p>
                  ) : (
                    <>
                      <div className="mc-date-grid">
                        {dates.map((d) => {
                          const dateObj = new Date(d.date);
                          const day = dateObj.getDate().toString().padStart(2, "0");
                          return (
                            <div
                              key={d.date}
                              className={`mc-date-circle ${selectedDate?.date === d.date ? "selected" : ""}`}
                              onClick={() => handleDateSelect(d)}
                            >
                              {day}
                            </div>
                          );
                        })}
                      </div>
                      <p className="tophe">
                        These are the dates you visited {selectedStore.name} via CashKaroNa
                      </p>
                    </>
                  )}
                </>
              )}

              {/* STEP 3: Order ID */}
              {step === 3 && selectedStore && (
                <>
                  <div className="mc-store-header">
                    <img
                      src={`${process.env.REACT_APP_API}uploads/${selectedStore.logo}`}
                      alt={selectedStore.name}
                    />
                  </div>
                  <h2>Now, tell us your {selectedStore.name} order ID</h2>

                  <div className="mc-input-wrapper">
                    <label>Enter Order ID</label>
                    <input
                      type="text"
                      value={orderId}
                      onChange={(e) => setOrderId(e.target.value)}
                      placeholder="e.g. 1117714-8685547-4990903"
                    />
                    <p className="mc-hint-text">
                      You'll find this in your {selectedStore.name} order confirmation email or SMS, or under "My Orders" on {selectedStore.name}'s website/app.
                    </p>
                  </div>

                  <button className="mc-btn-continue" onClick={handleOrderIdContinue}>
                    Continue
                  </button>
                </>
              )}

              {/* STEP 4: Amount + Description */}
              {step === 4 && (
                <>
                  <h2>Order details</h2>

                  <div className="mc-input-wrapper">
                    <label>Order Amount (₹)</label>
                    <input
                      type="number"
                      value={orderAmount}
                      onChange={(e) => setOrderAmount(e.target.value)}
                      placeholder="e.g. 1500"
                    />
                  </div>

                  <div className="mc-input-wrapper">
                    <label>Description (optional)</label>
                    <textarea
                      rows={3}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Any extra details you want to share"
                    />
                  </div>

                  <button className="mc-btn-continue" onClick={handleSubmit} disabled={submitting}>
                    {submitting ? "Submitting..." : "Submit Claim"}
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </section>

      <Footer />

      <style jsx="true">{`
        .mc-breadcrumb {
          padding: 12px 0;
          font-size: 0.9rem;
          color: #555;
        }
        .mc-breadcrumb span {
          cursor: pointer;
          color: #e8281a;
        }
        .mc-section {
          padding: 2rem 0 4rem;
        }
        .mc-header-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1.5rem;
        }
        .mc-btn-primary {
          background: #2f5bff;
          color: #fff;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
        }
        .mc-box {
          border: 1px solid #eee;
          border-radius: 12px;
          padding: 2.5rem 1.5rem;
          text-align: center;
          position: relative;
        }
        .mc-box h2 {
          font-weight: 700;
          margin-bottom: 1rem;
        }
        .tophe {
          color: #777;
          margin-bottom: 2rem;
        }
        .mc-back-arrow {
          position: absolute;
          left: 20px;
          top: 20px;
          cursor: pointer;
          font-size: 1.2rem;
        }
        .mc-grid {
          display: flex;
          justify-content: center;
          gap: 1.5rem;
          flex-wrap: wrap;
        }
        .mc-card {
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 1.5rem 2rem;
          cursor: pointer;
          transition: all 0.25s ease;
          min-width: 160px;
        }
        .mc-card:hover {
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
          transform: translateY(-3px);
        }
        .mc-card img {
          max-width: 100px;
          max-height: 40px;
          object-fit: contain;
          margin-bottom: 0.8rem;
        }
        .mc-track-time {
          font-size: 0.85rem;
          color: #2f5bff;
          margin: 0;
        }
        .mc-loading {
          color: #777;
        }
        .mc-store-header img {
          max-width: 120px;
          max-height: 50px;
          object-fit: contain;
          margin-bottom: 1rem;
        }
        .mc-date-grid {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin: 1.5rem 0;
          flex-wrap: wrap;
        }
        .mc-date-circle {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          border: 2px solid #2f5bff;
          color: #2f5bff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-weight: 600;
        }
        .mc-date-circle.selected,
        .mc-date-circle:hover {
          background: #2f5bff;
          color: #fff;
        }
        .mc-input-wrapper {
          max-width: 400px;
          margin: 1.5rem auto;
          text-align: left;
        }
        .mc-input-wrapper label {
          display: block;
          margin-bottom: 6px;
          font-weight: 600;
        }
        .mc-input-wrapper input,
        .mc-input-wrapper textarea {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 0.95rem;
        }
        .mc-btn-continue {
          background: #2f5bff;
          color: #fff;
          border: none;
          padding: 12px 40px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          font-size: 1rem;
        }
        .mc-btn-continue:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        .mc-claims-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        .mc-claim-card {
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 1.2rem 1.5rem;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }
        .mc-claim-store {
          font-weight: 700;
          margin: 0 0 4px;
        }
        .mc-claim-detail {
          font-size: 0.9rem;
          color: #666;
          margin: 2px 0;
        }
        .mc-claim-resolved {
          font-size: 0.9rem;
          color: #22c55e;
          font-weight: 600;
          margin: 4px 0 0;
        }
        .mc-claim-note {
          font-size: 0.8rem;
          color: #888;
          margin: 4px 0 0;
        }
        .mc-status-badge {
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          white-space: nowrap;
        }
          .mc-admin-message {
  background: #eef4ff;
  border-left: 3px solid #2f5bff;
  padding: 8px 12px;
  border-radius: 6px;
  margin-top: 8px;
}
.mc-admin-message strong {
  font-size: 0.8rem;
  color: #2f5bff;
  display: block;
  margin-bottom: 2px;
}
.mc-admin-message p {
  font-size: 0.85rem;
  color: #444;
  margin: 0;
}
      `}</style>
    </>
  );
};

export default MissingCashback;